var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#40D9B5",
    className: "a",
    d: "M14,18a.67.67,0,0,1-.67.67H2A.67.67,0,0,1,1.33,18V6.69A.67.67,0,0,1,2,6H9.87l1.34-1.33H2a2,2,0,0,0-2,2V18a2,2,0,0,0,2,2H13.31a2,2,0,0,0,2-2V8.79L14,10.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#40D9B5",
    className: "a",
    d: "M14.93,2.84,4.8,13l-.42,2.64L7,15.2,17.16,5.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#40D9B5",
    className: "a",
    d: "M19.54.46a1.58,1.58,0,0,0-2.22,0L16,1.8,18.2,4l1.34-1.34A1.58,1.58,0,0,0,19.54.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditComment);
export default __webpack_public_path__ + "static/media/edit-comment.eb1c267d78e458353eb1fa2f9fae8d9b.svg";
export { ForwardRef as ReactComponent };